import { LegalLayout, LegalSection, Todo } from "@/pages/legal/LegalLayout";
import { SITE, LEGAL } from "@/config/site";

const V = ({ children }) => (children === "À COMPLÉTER" ? <Todo>À compléter</Todo> : children);

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" crumbLabel="Mentions légales" path="/mentions-legales" description="Mentions légales du site FRELONS50.">
      <p className="text-sm italic">Informations légales de l'entreprise FRELONS50.</p>

      <LegalSection heading="Éditeur du site">
        <p>Entrepreneur : <V>{LEGAL.raisonSociale}</V></p>
        <p>Forme juridique : <V>{LEGAL.formeJuridique}</V></p>
        <p>SIREN : <V>{LEGAL.siren}</V> — SIRET : <V>{LEGAL.siret}</V></p>
        <p>Code APE : <V>{LEGAL.ape}</V></p>
        <p>Activité : <V>{LEGAL.activite}</V></p>
        <p>Adresse : <V>{LEGAL.adresse}</V></p>
        <p>Téléphone : {SITE.phoneDisplay}</p>
        <p>E-mail : {SITE.email}</p>
        <p>Directeur de la publication : <V>{LEGAL.directeurPublication}</V></p>
      </LegalSection>

      <LegalSection heading="Hébergement">
        <p>Hébergeur : <V>{LEGAL.hebergeur}</V></p>
      </LegalSection>

      <LegalSection heading="Conception et réalisation">
        <p>Site conçu et réalisé par {LEGAL.realisation}.</p>
      </LegalSection>

      <LegalSection heading="Propriété intellectuelle">
        <p>L'ensemble des contenus de ce site (textes, visuels, logo) est protégé. Toute reproduction sans autorisation est interdite.</p>
      </LegalSection>

      <LegalSection heading="Responsabilité">
        <p>Les informations diffusées sont fournies à titre indicatif. FRELONS50 ne saurait être tenue responsable d'une mauvaise utilisation de ces informations.</p>
      </LegalSection>
    </LegalLayout>
  );
}
